import { BRAND } from '../../brand';
/**
 * Aviso previo del filtro de datos personales (R8.4). Replica `qrcl/core/pii.py` solo para avisar antes de
 * enviar: el reemplazo que vale es el del backend.
 */
export type PiiKind = 'rut' | 'email' | 'phone';

export const PII_MARK: Record<PiiKind, string> = { rut: '[RUT]', email: '[EMAIL]', phone: '[TELÉFONO]' };
export const PII_LABEL: Record<PiiKind, string> = { rut: 'un RUT', email: 'un email', phone: 'un teléfono' };

const EMAIL = /(?<![\w.+-])[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*\.[A-Za-z]{2,}(?![\w-])/g;
const RUT = /(?<![\w$.,])(\d{1,2}\.\d{3}\.\d{3}|\d{7,8})(?:-([\dkK])|([kK]))(?!\w)/g;
const PHONE = /(?<![\w$])(?:\+?56[\s.-]?9[\s.-]?\d{4}[\s.-]?\d{4}|\+?56[\s.-]?2[\s.-]?\d{4}[\s.-]?\d{4}|(?<!\d)9[\s.-]?\d{4}[\s.-]?\d{4})(?!\d)/g;

export function rutDv(body: string): string {
  let total = 0;
  let factor = 2;
  for (const digit of body.split('').reverse()) {
    total += Number(digit) * factor;
    factor = factor === 7 ? 2 : factor + 1;
  }
  const rest = 11 - (total % 11);
  return rest === 11 ? '0' : rest === 10 ? 'K' : String(rest);
}

export function filterPii(text: string): { text: string; kinds: PiiKind[] } {
  const kinds = new Set<PiiKind>();
  let out = text.replace(EMAIL, () => {
    kinds.add('email');
    return PII_MARK.email;
  });
  out = out.replace(RUT, (match, body: string, dv?: string, dvk?: string) => {
    const digits = body.replace(/\./g, '');
    const check = (dv ?? dvk ?? '').toUpperCase();
    if (digits.length < 7 || digits.length > 8 || rutDv(digits) !== check) return match;
    kinds.add('rut');
    return PII_MARK.rut;
  });
  out = out.replace(PHONE, () => {
    kinds.add('phone');
    return PII_MARK.phone;
  });
  return { text: out, kinds: [...kinds] };
}

export function piiWarning(kinds: PiiKind[]): string | null {
  if (kinds.length === 0) return null;
  const list = kinds.map((k) => PII_LABEL[k]);
  const joined = list.length > 1 ? `${list.slice(0, -1).join(', ')} y ${list[list.length - 1]}` : list[0];
  return `Detectamos ${joined}. Se guardará reemplazado por una marca: ${BRAND} no almacena datos personales del negocio.`;
}
